// 颜色格式 hex 转 rgba
// 例如传入#10EBE4，输出的是rgba(16,235,228,0.15)

export const hexToRgba = (bgColor, option = 0.4) => {
  let color = bgColor.trim().slice(1) // 去掉'#'号
  let cl = color.length
  if (cl === 3) {
    color = color.replace(/(.)(.)(.)/, '$1$1$2$2$3$3')
  }

  let rgba = [
    parseInt('0x' + color.slice(0, 2)),
    parseInt('0x' + color.slice(2, 4)),
    parseInt('0x' + color.slice(4, 6)),
    option,
  ]

  return 'rgba(' + rgba.toString() + ')'
}
